import { render } from "./BusinessReadinessModal.vue?vue&type=template&id=487aa11b&scoped=true"
import script from "./BusinessReadinessModal.vue?vue&type=script&lang=js"
export * from "./BusinessReadinessModal.vue?vue&type=script&lang=js"

import "./BusinessReadinessModal.vue?vue&type=style&index=0&id=487aa11b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487aa11b"]])

export default __exports__